import { memo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import VNPlusButton from './VNPlusButton'
import { getOrderNotes } from '../../selectors/cart'
import useGetIsMobileScreen from '../../hooks/useGetIsMobileScreen'
import useOfflineModal from '../../hooks/useOfflineModal'
import { addOrderNotesToCart } from '../../actions/cart'
import { setEnteringInputDialog } from '../../VNDialogs/ActionCreators'
import styles from './VNCartButtons.module.scss'
import CartItem from '../../components/CartItem'

const VNOrderNotes = () => {
  const dispatch = useDispatch()
  const isMobileViewPort = useGetIsMobileScreen()
  const orderNotes = useSelector(getOrderNotes)
  const [checkIfOfflineWithCallback, offlineModal] = useOfflineModal()

  const orderNotesSubtext = isMobileViewPort
    ? 'Order Notes are not supported while the device is offline.'
    : 'Order Notes are not supported\nwhile the device is offline.'

  const notesHandler = useCallback(() => {
    checkIfOfflineWithCallback(
      () => {
        dispatch(
          setEnteringInputDialog({
            open: true,
            onSave: (orderNotes) => {
              dispatch(addOrderNotesToCart(`Note: ${orderNotes}`))
              dispatch(setEnteringInputDialog({ open: false }))
            },
            title: 'Order Notes',
            maxLength: 255,
            onSaveText: 'DONE',
            onCancelText: 'CANCEL',
            multiLine: true,
            preselect: true,
            regexExpression: /[^\x20-\x7E\n]/g,
          }),
        )
      },
      orderNotesSubtext,
      false,
    )
  }, [dispatch, checkIfOfflineWithCallback, orderNotesSubtext])

  const removeHandler = useCallback(() => {
    dispatch(addOrderNotesToCart(null))
  }, [dispatch])

  const notesInputHandler = useCallback(() => {
    dispatch(
      setEnteringInputDialog({
        open: true,
        onSave: (orderNotes) => {
          dispatch(addOrderNotesToCart(`Note: ${orderNotes}`))
          dispatch(setEnteringInputDialog({ open: false }))
        },
        title: 'Order Notes',
        maxLength: 255,
        onSaveText: 'DONE',
        onCancelText: 'CANCEL',
        multiLine: true,
        preselect: true,
        defaultValue: orderNotes?.replace('Note: ', ''),
        regexExpression: /[^\x20-\x7E\n]/g,
      }),
    )
  }, [dispatch, orderNotes])

  if (!orderNotes) {
    return (
      <div className={styles.container}>
        {offlineModal}
        <span className={styles.title}>Notes</span>
        <VNPlusButton className={styles.button} onClick={notesHandler} />
      </div>
    )
  }

  return (
    <CartItem
      key={`${orderNotes}`}
      onRemove={removeHandler}
      className={styles.cartItem}
      isSpecialtyItem={true}
      onSpecialtyItemClick={notesInputHandler}
      name={orderNotes}
      numberOfLines={2} // to handle long notes
    />
  )
}

export default memo(VNOrderNotes)
